<script>
import {chartData} from '../stores/oders-store'
import ApexCharts from "apexcharts";

let chart
let priceSymbol
let priceChart

async function renderPriceChart() {
	//Check if Chart is already rendered
	if(priceChart == undefined){
		priceChart = new ApexCharts(chart, $chartData);
		priceChart.render();
	} else {
		priceChart.updateOptions($chartData)
	}
}

const getPriceSymbol = (lastPriceChange) => {
		
		if (lastPriceChange === "+") {
			priceSymbol = '<span class="text-success">&#9650;</span>'; // Green up triangle
		} else {
			priceSymbol = '<span class="text-danger">&#9660;</span>'; // Red down triangle
		}
		return priceSymbol;
};

$: if($chartData){
	renderPriceChart()
   }

</script>

<main>
	<div class="price-chart">
		<div class="price">
			{#if $chartData && priceChart!= undefined}
				{#await getPriceSymbol($chartData.lastPriceChange) then}
					<h5>LTT/ETH &nbsp; {@html priceSymbol} &nbsp; {$chartData.lastPrice}</h5>
				{/await}
			{/if}
			<div id="chart" bind:this={chart} />
		</div>
	</div>
</main>